import { TableColumnMeta } from "ds/components/Table/types";

export enum INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID {
  ID = "ID",
  VALUE = "VALUE",
  DESCRIPTION = "DESCRIPTION",
  CREATED_AT = "CREATED_AT",
  RUNTIME = "RUNTIME",
  TYPE = "TYPE",
  WRITE_ONLY = "WRITE_ONLY",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMNS_STORAGE_KEY =
  "intentProjectEnvironmentVariablesColumnsConfig";

export const INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_CONFIG: Partial<
  Record<INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID, TableColumnMeta>
> = {
  [INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.ID]: {
    id: INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.ID,
    title: "ID",
    minWidth: 150,
    defaultWidth: 230,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.DESCRIPTION]: {
    id: INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.VALUE]: {
    id: INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.VALUE,
    title: "Value",
    minWidth: 120,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.CREATED_AT]: {
    id: INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 180,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.DROPDOWN]: {
    id: INTENT_PROJECT_ENVIRONMENT_VARIABLES_COLUMN_ID.DROPDOWN,
    title: "Environment actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};
